import store from "../store";

export default function checkAuthForRoute(to) {
  const withUserTypesRoutes = to.matched.filter(record => {
    return Array.isArray(record.meta.requiredUserTypes) && record.meta.requiredUserTypes.length
  })

  if(withUserTypesRoutes.length) {
    if(!store.getters['user/isLogged'] || !store.state.user.profile) {
      return withUserTypesRoutes[withUserTypesRoutes.length - 1].meta.requiredUserTypes
    }

    for (const route of withUserTypesRoutes) {
      if(!route.meta.requiredUserTypes.includes(store.state.user.profile.user_type)) {
        return route.meta.requiredUserTypes
      }
    }
  }

  return false
}
